import styles from './spinner.module.scss';

type SpinnerProps = {
  className?: string;
  size?: string;
  borderWidth?: string;
  color?: string;
};

export const Spinner = ({ className = '', size, borderWidth, color }: SpinnerProps) => {
  return (
    <div className={`${styles.wrapper} ${className}`}>
      <span
        className={styles.spinner}
        style={{
          width: size,
          height: size,
          borderWidth,
          borderTopColor: color,
          borderLeftColor: color,
        }}
      ></span>
    </div>
  );
};
